var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgCarotRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.461,
    height: 21.634,
    viewBox: "0 0 12.461 21.634",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.637 21.134) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.253,10.651a2.156,2.156,0,0,0,2.887,0l7.84-7.466A1.783,1.783,0,1,0,17.449.673L10.91,6.838a.445.445,0,0,1-.588,0L2.963.442A1.787,1.787,0,0,0,.611,3.132Z",
    transform: "translate(0 0)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCarotRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Carot_Right.5bc3164f.svg";
export { ForwardRef as ReactComponent };